<template>
  <div v-if="isShow" >
    <v-text-field
      clearable
      persistent-hint
      v-model="dataPost[fieldName ? fieldName.name : dataField.name]"
      :label="dataField.title ? dataField.title : ''"
      :counter="dataField.params.count ? dataField.params.count : ''"
      :placeholder="dataField.placeHolder ? dataField.placeHolder : ''"
      :rules="dataField.params.required ? required : []"
      @change="change"
      :error="alerts[dataField.name] != null"
      :error-messages="alerts[dataField.name]"
      
      :type="dataField.params.type ? dataField.params.type : 'text'"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "TextField",
  props: ["dataField", "fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
    isShow: {
      get() {
        let v =this.dataPost[this.fieldName ? this.fieldName.name : this.dataField.name];
        return !(
          this.isChanged &&
          (this.dataField.class=='isHidden') && 
          (!(typeof v == 'undefined' || v == '')) 
        );
      },
    },
  },
  methods:{
    change(){
      this.alerts[this.dataField.name] = null ;
      this.isChanged = true;
    }
  },
  data: () => ({
    isChanged : false,
    required: [(v) => !!v || "this is required"],
  }),
};
</script>
